import { GridAlignment } from "@mui/x-data-grid";

const GridColBase: { flex: number; align: GridAlignment; headerAlign: GridAlignment, resizable: boolean } = {
  flex: 1,
  align: "center",
  headerAlign: "center",
  resizable: false,
};

export default GridColBase;
